module.exports = __webpack_public_path__ + "static/logo-3a12f772d0992de01983a2b7452c4a47.png";